CTAPopUp = new (function () {
	this.open = (id) => {
        console.log(id);
        const popup = document.getElementById(id);
        popup.classList.remove("hidden");
        popup.classList.add("flex");
        window.location.href = "#" + id;
    }

    this.close = (id) => {
        console.log(id);
        const popup = document.getElementById(id);
        popup.classList.add("hidden");
        popup.classList.remove("flex");
    }
})();
